import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const CaptureGraphic = () => {
  const data = useStaticQuery(graphql`
    query {
      captureGraphicImage: file(relativePath: { eq: "graphics/capture-graphic.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Img
      fluid={data.captureGraphicImage.childImageSharp.fluid}
      alt="Capture Graphic"
    />
  )
}

export default CaptureGraphic
